import type {EnsureUserProfileResult} from "@/lib/UserProfileEnsure";
import type {SessionSnapshot} from "@/lib/SessionResolver";
import type {UserProfile} from "@/lib/UserProfile";

export function snapshotFromEnsure(result?: EnsureUserProfileResult | null): SessionSnapshot | null {
    if (!result?.onboarding) {
        return null;
    }
    return {
        emailVerified: result.emailVerified,
        onboarding: result.onboarding,
        permissions: result.permissions,
        signupIntent: result.signupIntent ?? null,
        pendingAuthReturnTo: result.pendingAuthReturnTo ?? null,
        pendingAuthReturnToConsumed: result.pendingAuthReturnToConsumed,
        pendingAuthReturnToCreatedAtMs: result.pendingAuthReturnToCreatedAtMs ?? null,
    };
}

export function translatorProfileFromSnapshot(
    uid: string,
    snapshot: SessionSnapshot | null
): UserProfile | null {
    if (!snapshot) {
        return null;
    }
    return {
        uid,
        signupIntent: snapshot.signupIntent === "translator" ? "translator" : undefined,
        pendingAuthReturnTo: snapshot.pendingAuthReturnTo || undefined,
        pendingAuthReturnToConsumedAt: snapshot.pendingAuthReturnToConsumed
            ? new Date()
            : undefined,
        pendingAuthReturnToCreatedAt: snapshot.pendingAuthReturnToCreatedAtMs
            ? new Date(snapshot.pendingAuthReturnToCreatedAtMs)
            : undefined,
    };
}
